import { AxiosResponse } from 'axios';
import madriwaAPI from '../madriwa-api-service';
import { HeatIslandRequestDto } from './heat-island-request-dto';
import { LTSZoneDto } from './LTSZoneDto';

const getHeatIslandInfo = async (lng: number, lat: number) => {
  const url = '/api/v1/isladecalor';
  const body: HeatIslandRequestDto = {
    side_square: 1000,
    point: {
      type: 'Point',
      coordinates: {
        coordinates: [lng, lat],
      },
    },
  };
  const response: AxiosResponse<LTSZoneDto> = await madriwaAPI.post<LTSZoneDto>(url, body);
  return response.data;
};

let fetchSuggestionsController: AbortController;
const fetchSuggestions = async (search: string) => {
  const url = '/api/v1/isladecalor/address/autocomplete';
  fetchSuggestionsController && fetchSuggestionsController.abort();
  fetchSuggestionsController = new AbortController();
  const response: AxiosResponse<string[]> = await madriwaAPI.get<string[]>(url, {
    params: { address: search },
    signal: fetchSuggestionsController.signal,
  });
  return response.data;
};

let getLocationController: AbortController;
const getLocation = async (search: string) => {
  const url = '/api/v1/isladecalor/geocode';
  getLocationController && getLocationController.abort();
  getLocationController = new AbortController();
  const response: AxiosResponse<any> = await madriwaAPI.get<any>(url, {
    params: { address: search },
    signal: fetchSuggestionsController.signal,
  });
  return response.data;
};

const subscribeToMailingList = async (email: string, lang: string) => {
  const url = `/api/v1/isladecalor/subscribe?email=${encodeURIComponent(email)}&lang=${lang}`;
  const response: AxiosResponse<any> = await madriwaAPI.post<string[]>(url);
  return response.data;
};

const madriwaService = {
  getHeatIslandInfo,
  fetchSuggestions,
  getLocation,
  subscribeToMailingList,
};

export default madriwaService;
